import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const PdfIcon = ({ color = '#b41c1c', text = 'PDF' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default PdfIcon;
